<template>
    <div>
     <el-row style="margin-bottom:10px;">
       <!-- <el-button v-if="addOpportunityBusinessCheckImage"
         @click=" $form('addOpportunityBusinessCheckImage')"
         size='small'
         type="primary"
         style="float:right"
         icon='el-icon-circle-plus'
       >添加填写项约束
       </el-button> -->
     </el-row>
  
     <mytable
       :tableColums='tableColums_getHuBeiPoints'
       api='getHuBeiPoints'
       xupdateapi='updateSysKeyProject'
       :height="H-165" >
     </mytable>
  
 
    </div>
  </template>
  
  <script>
    export default {
      data(){
        return {
            theProjectId: "",
            obcKeyOne:1,
            obcKeyTwo:2,
            obcKeyArray:[
              {key:1,label:"1"},
              {key:2,label:"2"},
             
  
            ],
  
            tableColums_getHuBeiPoints: {
              $selection: false,
  
              // oiType: '限制字段key',
  
              dtName: '战队名称',
  
              dtPointsNumTotal: '总积分',
              dtPointsNumQikuan: '企宽积分',
              dtPointsNumZhuanxian: '专线积分',
              dtPointsNumMoneyYear: '年化积分',
              dtQikuanNum: '企宽数',
              dtZhuanxianMoney: '专线金额',
              dtMoneyYear: '年化金额',
          
  
            //   $operation: [
            //     '操作', 200,
            //     this.updateSysKeyProject && `@text: 编辑#success
            //      @click: $form("updateSysKeyProject",$row)
            //     `,
               
            //   ],
  
            },
        }
      },
  
      methods:{
           myform(submit, Myformdata) {
              Myformdata.projectId = this.theProjectId;
              var oiType = Myformdata.oiType;
              this.obcKeyArray.forEach(element => {
                if(element.key==oiType){
                  Myformdata.obciKeyLabel=element.label;
                }
              });
              submit();
          },
      },
      created() {
        this.theProjectId=A.local('$projectId');
        this.getHuBeiPoints({projectId:this.theProjectId});
      }
    }
  </script>
  
  <style scoped="scoped">
  </style>
  


// WEBPACK FOOTER //
// src/views/data/PointsDiy.vue